import { render, staticRenderFns } from "./PreviewGoodsItem.vue?vue&type=template&id=1ba3d696&scoped=true"
import script from "./PreviewGoodsItem.vue?vue&type=script&lang=ts"
export * from "./PreviewGoodsItem.vue?vue&type=script&lang=ts"
import style0 from "./PreviewGoodsItem.vue?vue&type=style&index=0&id=1ba3d696&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3d696",
  null
  
)

export default component.exports